import { lazy } from "react";

const UimAccordion = lazy(() => import("./uimAccordion/UimAccordion"));
const UimAccordionItem = lazy(
  () => import("./uimAccordion/uimAccordionItem/UimAccordionItem"),
);
const UimAlert = lazy(() => import("./uimAlert/UimAlert"));
const UimAROverlay = lazy(() => import("./uimAROverlay/UimAROverlay"));
const UimButtonAccessCode = lazy(
  () => import("./uimButtonAccessCode/UimButtonAccessCode"),
);
const UimButtonSpecialOffer = lazy(
  () => import("./uimButtonSpecialOffer/UimButtonSpecialOffer"),
);
const UimButtonThumb = lazy(() => import("./uimButtonThumb/UimButtonThumb"));
const UimButtonThumbText = lazy(() => import("./uimButtonThumbText/UimButtonThumbText"));
const UimCardDealer = lazy(() => import("./uimCardDealer/UimCardDealer"));
const UimCardDealerLarge = lazy(() => import("./uimCardDealerLarge/UimCardDealerLarge"));
const UimCardIcon = lazy(() => import("./uimCardIcon/UimCardIcon"));
const UimCardIconBullet = lazy(() => import("./uimCardIconBullet/UimCardIconBullet"));
const UimCardImg = lazy(() => import("./uimCardImg/UimCardImg"));
const UimCardWrapper = lazy(() => import("./uimCardWrapper/UimCardWrapper"));
const UimDealership = lazy(() => import("./uimDealership/UimDealership"));
const UimDropdown = lazy(() => import("./uimDropdown/UimDropdown"));
const UimErrorMessage = lazy(() => import("./uimErrorMessage/UimErrorMessage"));
const UimFooterMain = lazy(() => import("./uimFooterMain/UimFooterMain"));
const UimHeaderMain = lazy(() => import("./uimHeaderMain/UimHeaderMain"));
const UimHeaderTitle = lazy(() => import("./uimHeaderTitle/UimHeaderTitle"));
const UimIntroHero = lazy(() => import("./uimIntroHero/UimIntroHero"));
const UimLink = lazy(() => import("./uimLink/UimLink"));
const UimListIdxCollapsible = lazy(
  () => import("./uimListIdxCollapsible/UimListIdxCollapsible"),
);
const UimListIdxCollapsibleItem = lazy(
  () =>
    import("./uimListIdxCollapsible/uimListIdxCollapsibleItem/UimListIdxCollapsibleItem"),
);
const UimMenuNavSwiper = lazy(() => import("./uimMenuNavSwiper/UimMenuNavSwiper"));
const UimMenuOptionSetBullBar = lazy(
  () => import("./uimMenuOptionSetAccessory/UimMenuOptionSetAccessory"),
);
const UimMenuOptionSetColour = lazy(
  () => import("./uimMenuOptionSetColour/UimMenuOptionSetColour"),
);
const UimMenuOptionSetText = lazy(
  () => import("./uimMenuOptionSetText/UimMenuOptionSetText"),
);
const UimMenuOptionSetThumb = lazy(
  () => import("./uimMenuOptionSetThumb/UimMenuOptionSetThumb"),
);
const UimMenuOptionSetThumbText = lazy(
  () => import("./uimMenuOptionSetThumbText/UimMenuOptionSetThumbText"),
);
const UimMosaic = lazy(() => import("./uimMosaic/UimMosaic"));
const UimQuickLinks = lazy(() => import("./uimQuickLinks/UimQuickLinks"));
const UimSectionAccessory = lazy(
  () => import("./uimSectionAccessory/UimSectionAccessory"),
);
const UimSpecialOffers = lazy(() => import("./uimSpecialOffers/UimSpecialOffers"));
const UimSwiper = lazy(() => import("./uimSwiper/UimSwiper"));
const UimSwiperNav = lazy(() => import("./uimSwiperNav/UimSwiperNav"));
const UimSwiperSlides = lazy(() => import("./uimSwiperSlides/UimSwiperSlides"));
const UimSwiperSlidesItem = lazy(
  () => import("./uimSwiperSlides/uimSwiperSlidesItem/UimSwiperSlidesItem"),
);
const UimTable = lazy(() => import("./uimTable/UimTable"));
const UimTextHighlights = lazy(() => import("./uimTextHighlights/UimTextHighlights"));
const UimTextTitleDescription = lazy(
  () => import("./uimTextTitleDescription/UimTextTitleDescription"),
);
const UimTextTitleDescriptionIcon = lazy(
  () => import("./uimTextTitleDescriptionIcon/UimTextTitleDescriptionIcon"),
);
const UimThumbLarge = lazy(() => import("./uimThumbLarge/UimThumbLarge"));
const UimTile = lazy(() => import("./uimTile/UimTile"));
const UimTileContent = lazy(() => import("./uimTileContent/UimTileContent"));
const UimToast = lazy(() => import("./uimToast/UimToast"));
const UimTopHeader = lazy(() => import("./uimTopHeader/UimTopHeader"));

export {
  UimAccordion,
  UimAccordionItem,
  UimAlert,
  UimAROverlay,
  UimButtonAccessCode,
  UimButtonSpecialOffer,
  UimButtonThumb,
  UimButtonThumbText,
  UimCardDealer,
  UimCardDealerLarge,
  UimCardIcon,
  UimCardIconBullet,
  UimCardImg,
  UimCardWrapper,
  UimDealership,
  UimDropdown,
  UimErrorMessage,
  UimFooterMain,
  UimHeaderMain,
  UimHeaderTitle,
  UimIntroHero,
  UimLink,
  UimListIdxCollapsible,
  UimListIdxCollapsibleItem,
  UimMenuNavSwiper,
  UimMenuOptionSetBullBar,
  UimMenuOptionSetColour,
  UimMenuOptionSetText,
  UimMenuOptionSetThumb,
  UimMenuOptionSetThumbText,
  UimMosaic,
  UimQuickLinks,
  UimSectionAccessory,
  UimSpecialOffers,
  UimSwiper,
  UimSwiperNav,
  UimSwiperSlides,
  UimSwiperSlidesItem,
  UimTable,
  UimTextHighlights,
  UimTextTitleDescription,
  UimTextTitleDescriptionIcon,
  UimThumbLarge,
  UimTile,
  UimTileContent,
  UimToast,
  UimTopHeader,
};
